Ext.define('SA.view.EnableGeographicUnits', {
    alias: 'widget.enable-geographic-units',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-enable-geographic-units',

    initComponent() {
        this.hidden = this.project.getAllOptionalDiscoverableUnits().length === 0;

        this.items = [
            {
                xtype: 'component',
                cls: 'sa-enable-geographic-units-header',
                html: 'Enable Geographic units'
            }, {
                xtype: 'simple-container',
                cls: 'sa-enable-geographic-units-content',

                items: [
                    {
                        xtype: 'enable-geographic-units-fixed-section',
                        unitIds: this.project.getFixedDiscoverableUnits()
                    }, {
                        xtype: 'enable-geographic-units-optional-section',
                        project: this.project
                    }
                ]
            }
        ];

        this.callParent();
    }
});